export enum TradeType {
  CLEARED = 'cleared',
  BILATERAL = 'bilateral',
  INTERNAL = 'internal',
}

export enum UploadAction {
  VALIDATE = 'validate',
  UPLOAD = 'upload',
}

export interface TradeData {
  trade_type: string;
  contract_type: string;
  leg2_pricing_from?: string;
  leg2_pricing_to?: string;
  leg2_price?: string;
  clearer: string;
  broker: string;
  book: string;
  strategy: string;
  quantity: string;
  clearing_acct: string;
  contract_code: string;
  derivative: string;
  single_diff: string;
  date: string;
  trader: string;
  execution_id: string;
  leg_id: string;
  buy_sell: string;
  pricing_from: string;
  pricing_to: string;
  price: number;
  blocked: string;
  cash_settle: string;
  [key: string]: string | number | undefined;
}

export interface ValidationError {
  row: number;
  column: string;
  message: string;
}

export interface ValidateResponse {
  error_rows: number;
  success_rows: number;
  data: TradeData[];
  errors?: ValidationError[];
}

export interface UploadResponse {
  error_rows: number;
  success_rows: number;
  data: TradeData[];
  created_count?: number;
  failed_count?: number;
  created?: string[];
  duplicates?: string[];
}

export interface UploadResult {
  type: 'validate' | 'upload';
  message: string;
  executionIds?: string[];
  rowCount: number;
  createdCount?: number;
  failedCount?: number;
  duplicateCount?: number;
  tradeType: string;
  timestamp: string;
}

export interface FileUploadState {
  file: File | null;
  tradeType: TradeType;
  validateOnly: boolean;
  previewData: TradeData[];
  loading: boolean;
  activeStep: number;
  validationErrors: ValidationError[] | null;
  successMessage: UploadResult | null;
}

export interface UploadAfterValidateRequest {
  validated: boolean;
  data: TradeData[];
}

export interface UploadAfterValidateResponse {
  created_count: number;
  failed_count: number;
  success_rows: number;
  error_rows: number;
  created: string[];
  duplicates: string[];
  data?: TradeData[];
}